var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// x-dropdown-search-selection.ts
import "@adornis/base/utilTypes.js";
import { injectAttributesOf } from "@adornis/chemistry/directives/inject-attributes.js";
import "@adornis/chemistry/elements/components/x-flex.js";
import "@adornis/forms/x-input.js";
import "@adornis/forms/x-input.js";
import { html, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";
import { live } from "lit/directives/live.js";
import { createRef, ref } from "lit/directives/ref.js";
import { takeUntil } from "rxjs";
import { XDropdownSelection } from "./x-dropdown-selection.js";
var XDropdownSearchSelection = class extends XDropdownSelection {
  constructor() {
    super(...arguments);
    this._ignoreDefaultTrigger = true;
    this._toggleOnClick = false;
    this._inputReference = createRef();
  }
  connectedCallback() {
    super.connectedCallback();
    this.value.observable.pipe(takeUntil(this.disconnected)).subscribe((v) => {
      if (this.stringSuggestionOnly) {
        if (v && typeof v !== "string")
          throw new Error(
            `x-dropdown-search-selection in string-suggestion-only mode expects value to be a string, got ${v}`
          );
        if (v !== this._searchString.value)
          this._searchString.next(v ?? "");
      }
      const rendered = this.renderSelected(v) ?? "";
      if (rendered !== this._searchString.value)
        this._searchString.next(rendered);
    });
  }
  _trigger() {
    return html`
      <x-input
        ${injectAttributesOf(this, ["tabindex"])}
        ${ref(this._inputReference)}
        .value=${live(this._getInputValue())}
        @value-changed=${(e) => {
      if (this._searchString.value !== e.detail.value) {
        this._searchString.next(e.detail.value);
      }
      if (this.stringSuggestionOnly && this.value.value !== e.detail.value) {
        this.value.next(e.detail.value);
      }
    }}
        @icon-click=${() => this.dispatchEvent(new CustomEvent("icon-click"))}
        @cleared=${() => this._clear()}
        @focus=${(e) => this._onFocus(e)}
        @blur=${(e) => this._onBlur(e)}
      ></x-input>
    `;
  }
  _search() {
    return nothing;
  }
  _activate() {
    this._searchString.next(this._searchString.value);
    requestAnimationFrame(() => {
      this._inputReference.value?.focus();
    });
  }
  _onBlur(event) {
    if (!super._onBlur(event))
      return false;
    if (this.stringSuggestionOnly) {
      this.dispatchEvent(new CustomEvent("value-picked", { detail: { value: this.value.value, manual: true } }));
      return true;
    }
    const selected = this.renderSelected(this.value.value) ?? "";
    if (this._searchString.value !== selected)
      this._searchString.next(selected);
    return true;
  }
  _clear() {
    super._clear();
    this._ignoreNextFocus = false;
  }
  _getInputValue() {
    return this._searchString.value === void 0 ? this.renderSelected(this.value.value) : this._searchString.value;
  }
  focus() {
    super.focus();
    if (!this._inputReference.value)
      throw new Error("x-dropdown-search-selection must have finished rendering");
    this._inputReference.value?.focus();
    setTimeout(() => {
      this._inputReference.value?.select();
    }, 100);
  }
};
__decorateClass([
  property({ type: Boolean, attribute: "string-suggestion-only" })
], XDropdownSearchSelection.prototype, "stringSuggestionOnly", 2);
XDropdownSearchSelection = __decorateClass([
  customElement("x-dropdown-search-selection")
], XDropdownSearchSelection);
export {
  XDropdownSearchSelection
};
